export const iconFontAwesomeHolidaysFaceGrinHearts = (
	<i className="fa-solid fa-face-grin-hearts"></i>
);
